/* (ignored) */


//////////////////
// WEBPACK FOOTER
// readable-stream (ignored)
// module id = 1
// module chunks = 0